import React from 'react';
import './ConfidentialitePage.css';

const ConfidentialitePage = () => {
    return (
        <div className="policy-page-wrapper">
            <div className="container">
                <div className="policy-header center">
                    <span className="premium-label">SÉCURITÉ & CONFIANCE</span>
                    <h2 className="section-title">POLITIQUE DE <span className="text-gradient-blue">CONFIDENTIALITÉ</span></h2>
                </div>

                <div className="policy-content-card">
                    <div className="intro-text">
                        <p>Nous attachons une grande importance à la confidentialité de vos informations personnelles. Cette politique de confidentialité décrit comment nous collectons, utilisons et protégeons vos informations personnelles.</p>
                    </div>

                    <div className="policy-section">
                        <h3>Collecte d'informations</h3>
                        <p>Nous collectons les informations personnelles que vous nous fournissez directement, telles que votre nom, votre adresse e-mail et votre numéro de téléphone. Nous pouvons également collecter des informations automatiquement lorsque vous utilisez notre site web, telles que votre adresse IP, votre navigateur web et votre système d'exploitation.</p>
                    </div>

                    <div className="policy-section">
                        <h3>Utilisation des informations</h3>
                        <p>Nous utilisons vos informations personnelles pour répondre à vos demandes, traiter vos commandes et vous fournir des informations sur nos services. Nous pouvons également utiliser vos informations pour améliorer notre site web et personnaliser votre expérience utilisateur.</p>
                    </div>

                    <div className="policy-section">
                        <h3>Divulgation des informations</h3>
                        <p>Nous ne vendons pas, ne louons pas et ne divulguons pas vos informations personnelles à des tiers, sauf si cela est nécessaire pour répondre à une demande que vous avez formulée ou pour nous conformer à une obligation légale.</p>
                    </div>

                    <div className="policy-section">
                        <h3>Sécurité des informations</h3>
                        <p>Nous avons mis en place des mesures de sécurité appropriées pour protéger vos informations personnelles contre la perte, l'utilisation abusive, l'accès non autorisé, la divulgation, l'altération ou la destruction.</p>
                    </div>

                    <div className="policy-section">
                        <h3>Cookies</h3>
                        <p>Nous utilisons des cookies pour améliorer votre expérience utilisateur sur notre site web. Les cookies sont de petits fichiers de données qui sont stockés sur votre ordinateur lorsque vous visitez notre site web. Vous pouvez désactiver les cookies en modifiant les paramètres de votre navigateur web.</p>
                    </div>

                    <div className="policy-section">
                        <h3>Modification de la politique de confidentialité</h3>
                        <p>Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Toute modification sera affichée sur notre site web.</p>
                    </div>

                    <div className="policy-section">
                        <h3>Contact</h3>
                        <p>Si vous avez des questions concernant notre politique de confidentialité, veuillez nous contacter à l'adresse suivante : <a href="mailto:roulezpropre@gmail.com" className="policy-link">roulezpropre@gmail.com</a></p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ConfidentialitePage;
